module.exports = "/_next/static/images/ps-9e5d947ffd2e191a7a28deafc8d022d4.svg";